/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ItalicsInputs */

const en_italics = /** @type {(inputs: ItalicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italics`)
};

const fr_italics = /** @type {(inputs: ItalicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italique`)
};

const de_italics = /** @type {(inputs: ItalicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursivschrift`)
};

const it_italics = /** @type {(inputs: ItalicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corsivo`)
};

const ru_italics = /** @type {(inputs: ItalicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Курсив`)
};

const es_italics = /** @type {(inputs: ItalicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cursiva`)
};

const zh_cn2_italics = /** @type {(inputs: ItalicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`斜体`)
};

const ja_italics = /** @type {(inputs: ItalicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イタリック体`)
};

const hi_italics = /** @type {(inputs: ItalicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तिर्छा`)
};

const pt_pt2_italics = /** @type {(inputs: ItalicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itálico`)
};

/**
* | output |
* | --- |
* | "Italics" |
*
* @param {ItalicsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const italics = /** @type {((inputs?: ItalicsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ItalicsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_italics(inputs)
	if (locale === "de") return de_italics(inputs)
	if (locale === "it") return it_italics(inputs)
	if (locale === "ru") return ru_italics(inputs)
	if (locale === "es") return es_italics(inputs)
	if (locale === "zh-CN") return zh_cn2_italics(inputs)
	if (locale === "ja") return ja_italics(inputs)
	if (locale === "hi") return hi_italics(inputs)
	if (locale === "pt-PT") return pt_pt2_italics(inputs)
	return en_italics(inputs)
});